import dynamic from "next/dynamic";
import React, { useState, useEffect } from "react";
import Sites from "../../constants/Sites";
import styles from "./SingleColumnLayout.module.css";
import { useTabletDetection } from "helpers/useTabletDetection";
import { shouldShowFloatingMenu } from "helpers/Helper";

import "./GlobalLayout1.css";
import EBBMenu from "@components/Header/EBBMenu/EBBMenu";
import EBBBottomNav from "@components/Header/EBBBottomNav/EBBBottomNav";
import ContentHeader from "@components/HeaderPage/ContentHeader";
import CatalogHeader from "@components/HeaderPage/CatalogHeader";

//Dynamic import based on https://github.com/zeit/next.js/blob/canary/examples/with-dynamic-import/pages/index.js
// {/ Load immediately, but in a separate bundle / }
const Header = dynamic(() => import("../Header/Header"));
const Footer = dynamic(() => import("../Footer"));
const NewHeader = dynamic(() => import("../Header/NewHeader"));

const SingleColumnLayout = (props) => {
  const {
    siteId,
    isMobile,
    subscriberCookie,
    isNonClosableModalChecked,
    isTablet: serverIsTablet,
    postType,
    isSimilarTitlesPage,
  } = props || {};
  const [activeBottomNavIndex, setActiveBottomNavIndex] = useState(null);

  // Enhanced client-side tablet detection using custom hook
  const { isTablet, isLargeTablet } = useTabletDetection(
    serverIsTablet,
    isMobile
  );

  const isHeader = parseInt(siteId) === Sites.EARLYBIRDBOOKS ? false : true;
  const handleBottomNavChange = (idx) => {
    setActiveBottomNavIndex(idx);
  };

  const handleMenuClose = () => {
    setActiveBottomNavIndex(null);
  };

  // Check if floating menu should be shown based on post type and device
  const showFloatingMenu = shouldShowFloatingMenu(postType, isMobile, isTablet);
  return (
    <React.Fragment>
      {isHeader ? (
        <>
          <Header isNonClosableModalChecked={isNonClosableModalChecked} />
          {!isMobile && !isTablet && siteId !== Sites.OPENROADMEDIA && (
            <ContentHeader isMobile={isMobile} isTablet={isTablet} />
          )}
          {!isMobile && siteId === Sites.OPENROADMEDIA && <CatalogHeader />}
        </>
      ) : (
        <>
          <NewHeader
            activeBottomNavIndex={activeBottomNavIndex}
            onMenuClose={handleMenuClose}
            isNonClosableModalChecked={isNonClosableModalChecked}
          />
          {!isMobile && !isTablet && <EBBMenu />}
          {(isMobile || isTablet) && showFloatingMenu && (
            <EBBBottomNav activeBottomNavIndex={handleBottomNavChange} />
          )}
        </>
      )}
      <div
        className={[
          styles["container_singleColumn"],
          "container_singleColumn",
          isSimilarTitlesPage ? styles.similarTitlesLayout : "",
        ]
          .filter(Boolean)
          .join(" ")}
        // style={{
        //   "--top-padding-1024": !subscriberCookie ? "58px" : isMobile ? "25px" : "48px",
        //   "--top-padding-712": !subscriberCookie ? siteId == Sites.EARLYBIRDBOOKS ? "0" : "15px" : "15px",
        // }}
      >
        {props.children}
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default SingleColumnLayout;
